<div class="user-ava" [ngClass]="size">
  <img class="user-ava__img" [src]="queryBaseUrl + '/users/' + user.userId + '/photo' | image | async" alt="" />
  <div class="user-ava__short-name">{{ (user.firstName || ' ').charAt(0) }}{{ (user.lastName || ' ').charAt(0) }}</div>
</div>
